export enum ZendeskOAuthScope {
  ReadArticles = 'hc:read',
  // NOTE: tickets:write scope is only required for uploading attachments
  CreateTicket = 'requests:write tickets:write',
}
